import { Helmet } from "react-helmet-async";
import { useEffect, useState } from "react";
import { doc, getDoc } from "firebase/firestore";
import { db } from "../../firebase/firebaseConfig";
import { useTranslation } from "react-i18next";

function SeoMeta({ page, initialMeta }) {
  const { i18n } = useTranslation();
  const [meta, setMeta] = useState({ title: "", description: "" });

  useEffect(() => {
    async function fetchMeta() {
      const snap = await getDoc(doc(db, "seo_meta", page));
      if (snap.exists()) {
        const d = snap.data();
        setMeta({
          title: d.title?.[i18n.language] || "",
          description: d.description?.[i18n.language] || "",
        });
      }
    }
    if (initialMeta) {
      setMeta(initialMeta);
    } else {
      fetchMeta();
    }
  }, [initialMeta, page, i18n.language]);

  return (
    <Helmet>
      <title>{meta?.title}</title>
      <meta name="description" content={meta?.description} />
    </Helmet>
  );
}
export default SeoMeta;
